import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable()
export class ActionPlanResponseAttachmentService {
  path = "/action-plan-response-attachment";

  constructor(private baseService: BaseService) {}

  getPaginated(init: number, end: number, filters: object) {
    return this.baseService.get(this.path, "", { init, end, ...filters });
  }

  getActionPlan(id: number) {
    return this.baseService.get(this.path, `/byActionPlan/${id}`, { id });
  }

  createAttachment(data) {
    return this.baseService.post(this.path, '',  {...data })
  }
  downloadAttachment (id) {
    return this.baseService.getFile(this.path, `/attachment/${id}`, {id})
  }
  //   exportCsv(filters: object) {
  //     return this.baseService.get(this.path, "/export/csv", filters);
  //   }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/action-plan-response-attachment.service.ts